import AxiosInstance from 'utils/AxiosInstance'
import * as types from './constants'
/*eslint-disable */

export const toggleNewStoreOverlay = () => ({ type: types.TOGGLE_OVERLAY })

export const onChangeStoreName = (value) => ({
  type: types.SET_STORE_NAME,
  value,
})
export const onChangeStoreId = (value) => ({ type: types.SET_STORE_ID, value })
export const setCurrentStore = (value) => ({
  type: types.SET_CURRENT_STORE,
  value,
})
export const onChangeCurrentStoreName = (value) => ({
  type: types.SET_CURRENT_STORE_NAME,
  value,
})
export const onChangeCurrentStoreId = (value) => ({
  type: types.SET_CURRENT_STORE_ID,
  value,
})
export const toggleStatus = () => ({ type: types.TOGGLE_STATUS })
export const setPaginationItems = (items) => ({ type: types.SET_ITEMS, items })
export const setPaginationPageOfItems = (pageOfItems) => ({
  type: types.SET_PAGE_OF_ITEMS,
  pageOfItems,
})
export const toggleCurrentStatus = () => ({
  type: types.TOGGLE_CURRENT_STATUS,
})

export const fetchStores = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_STORES_LOADED, value: false })
    const formatedStores = []
    AxiosInstance.get(`/stores`).then((stores) => {
      if (Array.isArray(stores)) {
        stores.map((item) => {
          formatedStores.push({
            ...item,
            status: item.status === 'Active' ? true : false,
          })
        })

        dispatch({ type: types.SET_LOCATIONS, stores: formatedStores })
        dispatch({ type: types.SET_STORES_LOADED, value: true })
      }
    })
  }
}

export const fetchAllStores = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_STORES_LOADED, value: false })

    AxiosInstance.get(`/stores/all`).then((stores) => {
      if (Array.isArray(stores)) {
        dispatch({ type: types.SET_ALL_LOCATIONS, stores })
        dispatch(setPaginationItems(stores))
        dispatch({ type: types.SET_STORES_LOADED, value: true })
      }
    })
  }
}

export const addNewStore = () => {
  return (dispatch, getState) => {
    console.log('getState().stores', getState().stores)
    const { storeName, stores, storeId, status } = getState().stores
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (!storeName) {
      alert(language.alerts ? language.alerts.type_loction_name : null)
      return
    }

    const storeIndex = stores.findIndex(
      (item) =>
        item.name.toLowerCase().trim() === storeName.toLowerCase().trim()
    )

    if (storeIndex === -1) {
      AxiosInstance.post('/stores', {
        name: storeName,
        location_id: storeId,
        status: status ? '1' : -1,
      }).then(() => {
        dispatch({ type: types.TOGGLE_OVERLAY })
        dispatch({ type: types.SET_STORE_NAME, storeName: '' })
        dispatch({ type: types.SET_STORE_ID, storeId: '' })
        dispatch(fetchAllStores())
        dispatch(fetchStores())
      })
    } else {
      alert(language.alerts ? language.alerts.location_already_exists : null)
    }
  }
}

export const toggleEditOverlay = (item) => {
  return (dispatch) => {
    let formatedItem
    if (item) {
      formatedItem = {
        ...item,
        status: item.status === 'Active' ? true : false,
      }
      dispatch(setCurrentStore(formatedItem))
    }

    dispatch({ type: types.TOGGLE_EDIT_OVERLAY })
  }
}

export const updateStore = () => {
  return (dispatch, getState) => {
    const { currentStore } = getState().stores
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (!currentStore.name) {
      alert(language.alerts ? language.alerts.type_loction_name : null)
      return
    }

    AxiosInstance.put(`/stores/${currentStore.id}`, {
      name: currentStore.name,
      location_id: currentStore.location_id,
      status: currentStore.status ? '1' : -1,
    }).then(() => {
      dispatch({
        type: types.TOGGLE_EDIT_OVERLAY,
      })
      dispatch({ type: types.SET_STORE_NAME })
      dispatch({ type: types.SET_STORE_ID })
      dispatch({ type: types.TOGGLE_STATUS })
      dispatch(fetchAllStores())
      dispatch(fetchStores())
    })
  }
}

export const deleteStore = (id) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (
      confirm(language.alerts ? language.alerts.delete_location_confirm : null)
    ) {
      AxiosInstance.delete(`/stores/${id}`).then(() => {
        dispatch(fetchAllStores())
        dispatch(fetchStores())
      })
    }
  }
}

export const setSearchValue = (searchValue) => {
  return (dispatch, getState) => {
    // const { allStores } = getState().stores
    // const filteredItems = allStores.filter(item => item.name.trim().toLowerCase().indexOf(searchValue.toLowerCase()) !== -1)
    // dispatch(setPaginationItems(filteredItems))
    dispatch({ type: types.SET_SEARCH_VALUE, searchValue })
  }
}

export const onClickSearch = () => {
  return (dispatch, getState) => {
    const { searchValue, allStores } = getState().stores
    const filteredItems = allStores.filter(
      (item) =>
        item.name.trim().toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
    )
    dispatch(setPaginationItems(filteredItems))
    dispatch({ type: types.SET_SERACH_VALUE_ON_CLICK, value: searchValue })
  }
}
export const onResetSearch = () => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_SERACH_VALUE_ON_CLICK, value: '' })
    dispatch({ type: types.SET_SEARCH_VALUE, searchValue: '' })
    const { searchValue, allStores } = getState().stores
    const filteredItems = allStores.filter(
      (item) =>
        item.name.trim().toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
    )
    dispatch(setPaginationItems(filteredItems))
  }
}
